import { CalculatorState } from "./calculator.utility";
import { formatTime, Distance, Pace } from "./pace-fns/pace-fns";

export const createLogAppState = (state: CalculatorState) => ({
  time: formatTime(state.time),
  distance: createDistanceLogData(state.distance),
  pace: `${formatTime(state.pace.time)}/${createDistanceLogData(state.distance)}`,
});

export const createDistanceLogData = (distance: Distance): string => `${distance.units}${distance.unitOfMeasure}`;
export const createPaceLogData = (pace: Pace): string => `${formatTime(pace.time)}/${createDistanceLogData(pace.distance)}`;